import { styled } from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { CallAssistUpsellPopupButton } from "src/components/MonitoringPresets/CallAssistUpsellPopupButton"
import { usePostTrackNoiseSettingsCallAssistLearnMoreClickedEvent } from "src/data/analytics/queries/settingsAnalyticsQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { Divider } from "src/ui/Divider/Divider"
import { ExternalLink } from "src/ui/Link/ExternalLink"

export function NoiseAlertCAUpgradeDisclaimer() {
  const { t, langKeys } = useTranslate()

  const callAssistLearnMoreTrackingEvent =
    usePostTrackNoiseSettingsCallAssistLearnMoreClickedEvent()

  function handleLearnMoreClick() {
    callAssistLearnMoreTrackingEvent.mutate({
      context: "third_alert_card",
    })
  }

  return (
    <DisclaimerContainer>
      <Divider />
      <Text variant="subtitle">
        {t(langKeys.settings_noise_alerts_call_assist_trained_expert)}{" "}
        <CallAssistUpsellPopupButton context="noise_settings" />
      </Text>
      <Text variant="bodyS">
        {t(langKeys.settings_noise_alerts_call_assist_solve)}{" "}
        <ExternalLink
          beforeNav={handleLearnMoreClick}
          href="https://www.minut.com/product/minut-monitoring"
        >
          {t(langKeys.settings_noise_alerts_call_assist_learn_more)}
        </ExternalLink>
      </Text>
    </DisclaimerContainer>
  )
}

export const DisclaimerContainer = styled.div`
  padding-top: ${spacing.M};
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
`
